






import { ClientEnum } from '@/enums/client.enum';
import { ContextEnum } from '@/enums/context.enum';
import {CountryEnum, CountryType} from '@/enums/country.enum';
import { VehicleTypeEnum } from '@/enums/vehicle-type.enum';
import { traceLogAccess } from '@/services/trace.log.access.service';
import { Client } from '@/store/modules/authentication/interfaces';
import {AUTH_GET_CLIENT, AUTH_GET_COUNTRY, AUTH_GET_VEHICLETYPE} from '@/store/modules/authentication/types';
import { TupleDictionary } from '@/utils/tupleDictionary';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ReportPowerBiContainer from '../../components/report-powerbi-container/report-powerbi-container.vue';
import PbiDictWorkspaceId, { PbiWorkspacesEnum } from './pbi-dict-workspace-id';

@Component({
  name: 'PbiParticipationTrainingPage',
  components: { ReportPowerBiContainer }
})
export default class PbiParticipationTrainingPage extends Vue {
  @Getter(AUTH_GET_CLIENT)
  public client: Client;

  @Getter(AUTH_GET_COUNTRY)
  public country: CountryType;
  
  @Getter(AUTH_GET_VEHICLETYPE)
  public idVehicleType: number;
  
  private pbiDictWorkspaceId = new PbiDictWorkspaceId();
  public dictReports = new TupleDictionary<[ClientEnum, CountryType, VehicleTypeEnum], IPbiContainer>();
  public crrReport: IPbiContainer = { brand: '', workspaceId: '', reportId: '' };

  mounted() {
    this.dictReports.set([ClientEnum.GM, CountryEnum.Brasil, VehicleTypeEnum.Car], { brand: 'GM', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'b95c0cc3-2484-4a7b-afad-a22c233b5460' });
    this.dictReports.set([ClientEnum.Honda, CountryEnum.Brasil, VehicleTypeEnum.Car], { brand: 'Honda', workspaceId: this.pbiDictWorkspaceId.dictionary.get([PbiWorkspacesEnum.Neodash]), reportId: 'cb0f2d11-bc64-4938-8a5b-9ce85a0b69fe' });

    this.crrReport = this.dictReports.get([this.client.id, this.country, this.idVehicleType]);
    traceLogAccess.logAction(ContextEnum.Report, `${this.crrReport.brand} - Uso do GIG e Participação em Treinamentos`);
  }
}
